import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from './Menu';
import meds from 'icons/pills-50.png';
import history from 'icons/history-48.png';
import schedule from 'icons/schedule-50.png';
import menu from 'icons/menu-48.png';
import face from 'icons/face-48.png';
import ingredients from 'icons/ingredients-rx-48.png';



export default function BottomNav() {
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();

  const tabStyle = 'flex flex-col text-center justify-center items-center';
  const tabIcon = 'h-12 w-12';
  const tabText = 'text-sm font-bold';

  function onClose() {
    setOpenMenu(false);
  }

  function navTo(target) {
      if (target === 'menu') {
        setOpenMenu(!openMenu);
        return;
      }
      setOpenMenu(false); // just in case
      navigate(target);
  }

  function Tab({icon,name,target}) {
    return (
      <div className={tabStyle} onClick={() => navTo(target)}>
        <img className={tabIcon} src={icon} alt='' />
        <div className={tabText}>{name}</div>
      </div>
    )
  }

  return (
    <>
    <Menu openMenu={openMenu} onClose={onClose} />
    <section id='bottom-navigation' className='block fixed inset-x-0 bottom-0 z-10 bg-white shadow border-2 rounded-md border-slate-400'>
      <div id='tabs' className='flex justify-around mt-1'>
          <Tab icon={meds} name={'Meds'} target={'/'} />
          <Tab icon={history} name={'History'} target={'/history'} />
          <Tab icon={schedule} name={'Schedule'} target={'/schedule'} />
          {/* <Tab icon={face} name={'Condition'} target={'/condition'} />
          <Tab icon={ingredients} name={'Ingredients'} target={'/ingredients'} /> */}
          <Tab icon={menu} name={'Menu'} target={'menu'} />
      </div>
    </section>
    </>
  );
}
